// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AdditionalFields from './additional-fields';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRates from './labor-rates';
import {buildDealer} from '../../../shared/services/build-dealer';

const LaborRateMain = props =>
    <div className='labor-rate-change-panel'>
        <header>
            <span className='dealer-location'>
                {buildDealer(props.laborRate.responsibleAccount, '03')}<span className='currency'>{`(${props.laborRate.responsibleAccount.currency})`}</span>
            </span>
        </header>
        <LaborRates
            actions={props.actions}
            rates={props.laborRate.rates}
            tcsm={props.tcsm}
        />
        <AdditionalFields
            actions={props.actions}
            laborRate={props.laborRate}
            tcsm={props.tcsm}
        >
            {props.children}
        </AdditionalFields>
    </div>;

LaborRateMain.displayName = 'LaborRateMain';
LaborRateMain.propTypes = {
    actions: PropTypes.object.isRequired,
    children: PropTypes.node,
    laborRate: PropTypes.instanceOf(LaborRate).isRequired,
    tcsm: PropTypes.bool.isRequired
};

export default LaborRateMain;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/components/labor-rate-main.js